import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { UIRouterModule } from '@uirouter/angular';
import { UsersRoutingModule } from './users-routing.module';
import { UserListComponent } from './components/user-list/user-list.component';
import { SearchUserPipe } from './pipes/search-user.pipe';
import { UserEditComponent } from './components/user-edit/user-edit.component';
import { USERS_STATES } from './users.states';

@NgModule({
  declarations: [
    UserListComponent,
    SearchUserPipe,
    UserEditComponent
  ],
  imports: [
    SharedModule,
    UsersRoutingModule,
    UIRouterModule.forChild({ states: [...USERS_STATES] })

  ],
  entryComponents: [
    UserListComponent,
    UserEditComponent
  ]
})
export class UsersModule {

 }
